<template>
    <div>
        <div class="row">
            <div class="col-12 col-lg-9 mb-3">
                <div>
                    <p class="mt-3 h5 u-text-primary">Software Entwickler mit Herz <span class="text-white">●</span> nickhatboecker.de</p>
                    <h1><a class="logo link text-white" href="https://nickhatboecker.de">Alle haben Bock. Aber <span>Nick</span> hat <span>Böcker</span></a></h1>
                </div>
            </div>
        </div>
        <div class="mt-4 article">
            <h2 class="mb-5">Vita</h2>

            <h3>2015 - jetzt</h3>
            <p class="mb-4"><span class="job">Senior Software Architekt</span> ● snoopmedia GmbH</p>

            <h3>2012 - 2015</h3>
            <p class="mb-4"><span class="job">Ausbildung zum Fachinformatiker in Anwendungsentwicklung</span> ● snoopmedia GmbH</p>

            <h3>2012</h3>
            <p><span class="job">Allgemeine Hochschulreife (Abitur)</span> ● Reichenbach Gymnasium Ennepetal</p>

            <div class="u-separator my-5" />

            <template v-if="relevantTags && relevantTags.length">
                <h2 class="mb-5">Für euch relevante Fähigkeiten / Kenntnisse</h2>
                <ul class="list-unstyled">
                    <li v-for="(tag, i) in relevantTags" :key="`tag-${i}`" class="tag">{{ tag }}</li>
                </ul>
            </template>

            <h2 :class="{ 'mt-5': relevantTags && relevantTags.length, 'mb-5': true }">
                <template v-if="relevantTags && relevantTags.length">Weitere Fähigkeiten / Kenntnisse</template>
                <template v-else>Fähigkeiten / Kenntnisse</template>
            </h2>
            <ul class="list-unstyled">
                <li v-for="(tag, i) in tagsWithoutRelevantAndUnImportant" :key="`tag-${i}`" class="tag">{{ tag }}</li>
            </ul>

            <template v-if="notSoImportantTags.length">
                <h3 class="mt-5 mb-5">Nice2Have</h3>
                <ul class="list-unstyled">
                    <li v-for="(tag, i) in notSoImportantTags" :key="`nsi-tag-${i}`" class="tag">{{ tag }}</li>
                </ul>
            </template>

            <div class="u-separator my-5" />

            <h2 class="mb-5">Das wünsche ich mir</h2>
            <ul class="list-unstyled">
                <li class="tag">Vollzeit (40h)</li>
                <li class="tag">90k Jahresbrutto (VB)</li>
                <li class="tag">100% Home Office</li>
                <li class="tag">Team Zusammenhalt</li>
            </ul>

            <div class="u-separator my-5" />

            <h2 class="mb-5">snoopmedia Projekte (Auszug)</h2>

            <p><span class="job"><a href="https://daad.de" target="_blank">daad.de</a></span> ● Frontend</p>
            <p><span class="job"><a href="https://study-in-germany.de" target="_blank">study-in-germany.de</a></span> ● Backend / Frontend / Symfony API / Koordination</p>
            <p><span class="job"><a href="https://myguide.de" target="_blank">my-guide.de</a></span> ● Backend / Frontend / Symfony API / Koordination</p>
            <p><span class="job"><a href="https://www.projekt-hero.de/" target="_blank">Projekt Hero: ease</a></span> ● App Entwicklung (Quasar.js)</p>
            <p><span class="job"><a href="https://daad.de/" target="_blank">Cookie Consent</a></span> ● Entwicklung eines Website & Projekt übergreifenden Cookie Layers</p>

            <div class="u-separator my-5" />

            <h2 class="mb-5">Private Projekte</h2>

            <h3>2025</h3>
            <ul>
                <li
                    v-for="(project, i) in privateProjects[2025]"
                    :key="`project-2025-${i}`"
                >
                    <span class="job">{{ project.title }}</span>
                    <span v-if="project.description"> ● {{ project.description }}</span>
                </li>
            </ul>

            <h3>2024</h3>
            <ul>
                <li
                    v-for="(project, i) in privateProjects[2024]"
                    :key="`project-2024-${i}`"
                >
                    <span class="job">{{ project.title }}</span>
                    <span v-if="project.description"> ● {{ project.description }}</span>
                </li>
            </ul>

            <h3>2023</h3>
            <ul>
                <li
                    v-for="(project, i) in privateProjects[2023]"
                    :key="`project-2023-${i}`"
                >
                    <span class="job">{{ project.title }}</span>
                    <span v-if="project.description"> ● {{ project.description }}</span>
                </li>
            </ul>

            <h3>2022</h3>
            <ul>
                <li
                    v-for="(project, i) in privateProjects[2022]"
                    :key="`project-2022-${i}`"
                >
                    <span class="job">{{ project.title }}</span>
                    <span v-if="project.description"> ● {{ project.description }}</span>
                </li>
            </ul>

            <h3>2021</h3>
            <ul>
                <li
                    v-for="(project, i) in privateProjects[2021]"
                    :key="`project-2021-${i}`"
                >
                    <span class="job">{{ project.title }}</span>
                    <span v-if="project.description"> ● {{ project.description }}</span>
                </li>
            </ul>

            <h3>Älter</h3>
            <ul>
                <li
                    v-for="(project, i) in privateProjects.older"
                    :key="`project-older-${i}`"
                >
                    <span class="job">{{ project.title }}</span>
                    <span v-if="project.description"> ● {{ project.description }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Vita',

    data: () => ({
        tags: [
            'Full-Stack-Entwicklung', 'JavaScript / Node.js', 'VueJS', 'PHP', 'Symfony Framework', 'WordPress',
            'CSS3 / SASS / SCSS / LESS', 'git', 'GitHub CI/CD', 'REST', 'Docker', 'MySQL/MariaDB',
            'Accessibility / Barrierefreiheit (WCAG)', 'Responsive Design', 'Progressive Web App (PWA)',
            'Automated Testing', 'AdobeXD / Figma / InVision', 'Legacy Applications', 'Code Review', 'HTML Newsletter',
            'shopify',
        ],

        relevantTags: [],

        notSoImportantTags: [],

        privateProjects: {
            2025: [
                { title: 'Haven Prototyp', description: 'Katalog an Vue Komponenten, die via PackageManager in jedes Projekt eingebunden werden können.' },
                { title: 'Godot Components', description: 'Sammlung an Implementierungen für die Godot Engine' },
                { title: 'Cloth up', description: 'Sammlung an Kleidungsstücken und Outfit-Ideen, implementiert mit Vue 3 und WordPress REST Anbindung' },
                { title: 'Lyricly', description: 'Sammlung an Songtexten und YouTube Links als Vue 3 Website mit selfhosted AppWrite REST Anbindung' },
            ],
            2024: [
                { title: 'Godot Nachschlagewerk', description: 'Enthält Codeschnipsel, Artikel und Lesezeichen zu Godot relevanten Themen (Vue3 + WordPress REST)' },
                { title: 'Bill Manager', description: 'Verwaltung und Export von Rechnungen. Vue 3 Website mit selfhosted AppWrite REST Anbindung' },
                { title: 'Projekt Server', description: 'Einrichtung & Konfiguration einer virtuellen VM für diverse Projekte / Staging Umgebungen / etc' },
                { title: 'Find This Pixel Anomaly', description: 'Puzzle-Horror-Game mit der Godot Engine' },
            ],
            2023: [
                { title: 'Bonbon', description: 'Gesicherte Digitalisierung und Haltung von Dokumenten. Vue PWA mit Symfony API und Authentifizierung' },
                { title: 'ROAR', description: 'App über alle Informationen zu meinem Peugeot 2008. Vue PWA mit selfhosted AppWrite API' },
                { title: 'Shoppily', description: 'Verwalten von Einkaufslisten und Rezepten. Vue PWA mit selfhosted Appwrite API' },
                { title: 'Teilnahme am Appwrite Hackathon', description: '' },
            ],
            2022: [
                { title: 'DREAM Admininterface', description: 'Vue PWA mit Symfony API' },
                { title: 'Elgato Streamdeck:: Do not Disturb Mac', description: '' },
                { title: 'SFX Database', description: 'Vue Website und Firebase API' },
            ],
            2021: [
                { title: 'Corona-Maßnahmen-Generator', description: 'In den Top 3 der deutschen Twitter Trends' },
                { title: 'Linktree', description: 'Vue Website mit Symfony API' },
                { title: 'GameDev:: Ein Spiel mit JavaScript programmieren', description: 'Umsetzung via PhaserJS' },
                { title: 'Youtube Comment Checker', description: 'Symfony Anwendung mit Anbindung an Googles YouTube API' },
                { title: 'UNO Web-Klon', description: 'Umsetzung via PhaserJS' },
                { title: 'Alexa Skill:: Pokémon', description: 'Umsetzung via PHP' },
            ],
            older: [
                { title: 'GTM-Doc', description: 'Symfony Anwendung mit Google API' },
                { title: 'Host-it!', description: 'Virtual Host Manager für MacOS. Umsetzung via electronjs' },
                { title: 'Deploy-it!', description: 'Manager zum schnellen Deployment von Anwendungen/Websites. Umsetzung via electronjs' },
                { title: 'Bookmark Manager (App/API/Chrome Extension)', description: 'Vue Website mit Symfony API' },
                { title: 'Sublime Text:: CopyFilepathWithLineNumbers Plugin', description: 'Umsetzung via Python' },
                { title: 'Sublime Text:: SaveCopyAs Plugin', description: 'Umsetzung via Python' },
            ],
        },
    }),

    computed: {
        tagsWithoutRelevantAndUnImportant () {
            return this.tags.filter((tag) => {
                return !this.relevantTags.includes(tag) && !this.notSoImportantTags.includes(tag)
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.logo {
    text-decoration: none;
}

.link {
    &:hover, &:focus, &:active {
        text-decoration: none;
        color: $primary !important;
    }
}

.job {
    color: $primary;
    font-size: 1.5rem;
}

.tag {
    border: 1px solid $primary;
    color: $primary;
    padding: $spacing-unit;
    margin: $spacing-unit;
    display: inline-block;
}
</style>
